import Component from "@tunnel-components/@pages/fogetPassword/component";
import * as React from "react";
import { connect } from "react-redux";
import { EmailForgetPassWordActionCreator } from "@tunnel-store/index";
import * as Lodash from "lodash";
import * as Paths from "@tunnel-enums/index";
import { LoginContainerStates } from "@tunnel-models/index";
import * as EmailValidator from "email-validator";

/**
 * @class Container : Composant à état
 * @description : composant “complexe” recevant des props et possédant
 * un état interne pour générer son rendu.
 * @extends { React.PureComponent }
 * @implements
 * @method
 * @name componentWillUnmount
 * @name componentWillReceiveProps
 * @name render
 * @infos "https://cyclope.ai"
 */

class Container extends React.PureComponent<
  any,
  LoginContainerStates<any, boolean>
> {
  //  faire cette action toute les 50 millisecondes
  public debounceChange = Lodash.debounce((event: any) => {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      error: false,
      success: false,
      warning: false,
    }));
    {
      /** Empêcher la mutation du state */
    }
    this.setState({ [event.target.name]: event.target.value });
  }, 50);
  /**
   * @constructor
   * @description :
   * Le Constructor est invoqué en premier.
   * Il reçoit en argument toutes les props initiales du composant
   * Le Constructor est aussi utilisé pour Binder les events Handler à l’instance.
   * @param { objet <any> } props
   */
  public constructor(props: any) {
    /**
     * @function
     * @description : Utilisé afin d'appeler ou d'accéder
     * à des fonctions définies sur l'objet parent.
     */
    super(props);
    /**
     * @namespace
     * @property { object }       state
     * @property { boolean }      state.error
     * @property { boolean }      state.success
     * @property { string }       state.email
     * @property { boolean }      state.warning
     */
    this.state = {
      email: "",
      error: false,
      success: false,
      warning: false,
      submitSend: true,
    };
    /**
     * @description : Empêcher l'exécution des méthodes à chaque initialisation
     * des composants ; "seulement quand un event est exécuté"
     */
    this.onChangeValue = this.onChangeValue.bind(this);
    this.onSubmitValues = this.onSubmitValues.bind(this);
  }
  /**
   * Redirection après validation du mail
   * @public
   * @method
   * @name onSubmitValues
   * @param { React.ChangeEvent<HTMLInputElement>  }  event
   * @infos "https://reactjs.org"
   */
  public onSubmitValues = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      error: false,
      success: false,
      warning: false,
      submitSend: false,
    }));

    if (!Lodash.isEmpty(this.state.email)) {
      {
        /**  test du type ou existence du paramètre */
      }
      if (EmailValidator.validate(this.state.email)) {
        {
          /** Empêcher la mutation du state */
        }

        this.props.EmailForgetPassWordActionCreator(this.state.email);
      } else {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({
          warning: true,
          submitSend: true,
        }));
      }
    } else if (Lodash.isEmpty(this.state.email)) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({ warning: true, submitSend: true }));
    }
  };
  /**
   * manipulation des valeurs des inputs
   * @public
   * @method
   * @name onChangeValue
   * @param { React.ChangeEvent<HTMLInputElement>  }  event
   * @infos "https://reactjs.org"
   */
  public onChangeValue = (event: React.ChangeEvent<HTMLInputElement>): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    // Faire persister mon événement
    event.persist();

    /**
     * Afin d'améliorer la performance de l'interface on utilise des actions
     * espacé dans le temps
     */
    this.debounceChange(event);
  };
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentWillUnmount
   * @description : il est appelée.
   * Avant que le composant soit supprimé du DOM.
   * Cette méthode peut être utile lorsque vous devez effectuer
   * des opérations de nettoyage.
   * @param { void }
   * @infos "https://reactjs.org"
   */
  public componentWillUnmount() {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      error: false,
      success: false,
      warning: false,
      submitSend: true,
    }));

    // Stopper l'action une fois le component détruit
    this.debounceChange.cancel();
  }

  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentWillReceiveProps
   * @description : La méthode  est appelée uniquement lorsque les props
   * ont changé et lorsqu'il ne s'agit pas d'un rendu initial
   * Le composant passe par une autre série d’étapes lorsque son parent refait son rendu
   * C’est l’endroit idéal pour vérifier si vos props vont changer par exemple
   * @param { any } nextProps
   * @infos "https://reactjs.org"
   */
  public componentWillReceiveProps(nextProps: any) {
    {
      /** comparaison */
    }
    if (nextProps.emailpropsError !== this.props.emailpropsError) {
      if (!Lodash.isUndefined(nextProps.emailpropsError)) {
        this.setState((state: any): any => ({
          error: true,
          success: false,
          submitSend: true,
        }));
      }
    }
    if (nextProps.emailprops !== this.props.emailprops) {
      if (!Lodash.isUndefined(nextProps.emailprops)) {
        this.setState((state: any): any => ({ success: true }));
        {
          /**  vérification de l'existence du paramètre */
        }
        if (Lodash.isUndefined(this.props.emailpropsError)) {
          this.setState((state: any): any => ({ submitSend: true }));
          setTimeout(() => {
            const _URL = Paths.PathsNamesEnums.LOGIN;
            this.props.history.push(_URL);
          }, 2000);
        }
      }
    }
  }

  /**
   * Cycle de vie d'un composant react
   * @method
   * @name render
   * @description : il est appelée. Pour le rendu ,
   * Ici le DOM virtuel fusionne avec le DOM réel
   * @param {  }
   * @infos "https://reactjs.org"
   */
  public render() {
    return (
      <Component
        {...this.props}
        {...this.state}
        onChangeValue={this.onChangeValue}
        onSubmitValues={this.onSubmitValues}
      />
    );
  }
}
/**
 * @function
 * @name mapStateToProps
 * @description : mapStateToProps prend
 * un composant en entrée et retourne le même composant avec de props
 * @param { any } state
 * @infos "https://react-redux.js.org/using-react-redux/connect-mapstate"
 */
export function mapStateToProps(state: any) {
  {
    /** nouveaux props */
  }
  return {
    emailprops: state.EmailForgetPassWord.data,
    emailpropsError: state.EmailForgetPassWord.error,
  };
}
{
  /** exporter le HOC : connect */
}
export default connect(mapStateToProps, { EmailForgetPassWordActionCreator })(
  Container
);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/fogetPassword/container.tsx